var render, staticRenderFns
import script from "./chart-profit.vue?vue&type=script&lang=js&"
export * from "./chart-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded414a4",
  null
  
)

export default component.exports